import React from "react";
import trendingUp from "assets/images/trendingUp.svg";
import trendingDown from "assets/images/trendingDown.svg";
import { Image } from "react-bootstrap";

type Props = {
  isIncrease: boolean;
  isPercentage: boolean;
  amount: number;
  trendPercent: number;
  periodAverageTitle: string;
};

const ICON_SIZE = 20;

const Trend: React.FC<Props> = ({
  isIncrease,
  isPercentage,
  amount,
  trendPercent: trend,
  periodAverageTitle,
}) => {
  return (
    <div className="trend-container">
      <div className="amount">
        {amount}
        {isPercentage ? "%" : ""}
      </div>
      <div className="column">
        <p
          className="trend"
          style={{ color: isIncrease ? "#56cb47" : "#fe5050" }}
        >
          {isIncrease ? (
            <Image
              src={trendingUp}
              className="icon"
              width={ICON_SIZE}
              height={ICON_SIZE}
            />
          ) : (
            <Image
              src={trendingDown}
              className="icon"
              width={ICON_SIZE}
              height={ICON_SIZE}
            />
          )}
          {trend}%
        </p>
        <p className="period-average-title">{periodAverageTitle}</p>
      </div>
    </div>
  );
};

export default Trend;
